<template>
  <van-dialog
    v-model="show"
    theme="round-button"
    class="custom-dialog"
    title="提示"
    :show-cancel-button="true"
    :show-confirm-button="data.showConfirmButton"
    cancel-button-text="好的"
    :confirm-button-text="confirmButtonText"
    :before-close="beforeClose"
  >
    <div class="dialog-content">
      <div>{{ data.content }}</div>
      <div
        v-if="data.warningText"
        class="dialog-warning"
      >
        {{ data.warningText }}
      </div>
    </div>
  </van-dialog>
</template>

<script>
const initData = () => {
  return {
    content: '请引导客户重新下单',
    warningText: '',
    counter: 5,
    showConfirmButton: true,
    okCallback: null,
    insistCallback: null
  };
};

export default {
  name: 'AppointmentCheckTipsDialog',
  data() {
    return {
      data: initData(),
      show: false,
      timer: null,
      counter: 5,
      canInsist: false,
      confirmButtonText: '客户坚持预约(5s)'
    };
  },
  destroyed() {
    this.clearTimer();
  },
  methods: {
    open(data) {
      this.clearTimer();
      this.data = {
        ...initData(),
        ...data
      };
      this.counter = Number(this.data.counter) || 5;
      this.show = true;
      this.canInsist = false;
      this.updateConfirmButtonText();
      if (this.data.showConfirmButton && this.counter > 0) {
        this.initTimer();
      }
    },
    close() {
      this.show = false;
      this.clearTimer();
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        if (!this.canInsist) {
          done(false);
          return;
        }
        this.close();
        this.data.insistCallback && this.data.insistCallback();
        done();
        return;
      }

      if (action === 'cancel') {
        this.close();
        this.data.okCallback && this.data.okCallback();
      }
      done();
    },
    updateConfirmButtonText() {
      if (!this.data.showConfirmButton) {
        this.confirmButtonText = '';
        this.canInsist = false;
        return;
      }
      if (this.counter > 0) {
        this.confirmButtonText = `客户坚持预约(${this.counter}s)`;
        return;
      }
      this.confirmButtonText = '客户坚持预约';
      this.canInsist = true;
    },
    tickCounter() {
      this.counter -= 1;
      this.updateConfirmButtonText();
      if (this.counter <= 0) {
        this.clearTimer();
      }
    },
    initTimer() {
      if (this.timer || this.counter <= 0) {
        return;
      }
      this.timer = setInterval(() => {
        this.tickCounter();
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-dialog {
  &.van-dialog ::v-deep {
    .van-dialog__header {
      padding: 14px 0;
      text-align: center;
      color: #383838;
      border-radius: 8px 8px 0 0;
      background: #ffffff;
      box-shadow: inset 0 -1px 0 0 rgba(230, 230, 230, 1);
      font-size: 16px;
      font-weight: 400;
    }

    .van-dialog__content {
      .dialog-content {
        padding: 24px 16px;
        text-align: center;
        color: #646464;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;

        .dialog-warning {
          margin-top: 8px;
          color: #f32222;
          font-size: 14px;
        }
      }
    }

    .van-dialog__footer {
      padding: 0 16px 24px;

      .van-button {
        height: 40px;
        text-align: center;

        & + .van-button {
          margin-left: 17px;
        }

        &.van-dialog__cancel {
          color: #646464;
          border-radius: 8px;
          background: #edf2f7;
          font-size: 16px;
          font-weight: 400;
        }

        &.van-dialog__confirm {
          color: #ffffff;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 400;

          .van-button__text {
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
